export default __webpack_public_path__ + "static/banner-longhaul-flight-a1c8513d2bd52ae85908cff21a875068.jpg";